import { PricingSummaryKeys, TableColumn } from "@sso/types";

export const pricingTableColumns: TableColumn<string>[] = [
  {
    name: "Date Of Effect",
    field: PricingSummaryKeys.DATE_OF_EFFECT,
    sortable: true,
  },
  {
    name: "Last Edited",
    field: PricingSummaryKeys.UPDATE_DATE,
  },
  {
    name: "Edited By",
    field: PricingSummaryKeys.EDITED_BY,
  },
  {
    name: "Currencies",
    field: PricingSummaryKeys.CURRENCIES,
  },
];
